import { render, staticRenderFns } from "./View2.vue?vue&type=template&id=65f13427&"
import script from "./View2.vue?vue&type=script&lang=js&"
export * from "./View2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports